/**
 * @generated SignedSource<<9ca97a58eb5b8b731ae8dec85702dd06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonInfoBanner_booking$data = {
  readonly __typename: "LessonBooking";
  readonly lessonType: {
    readonly description: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "LessonInfoBanner_booking";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "LessonInfoBanner_booking";
};
export type LessonInfoBanner_booking$key = {
  readonly " $data"?: LessonInfoBanner_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonInfoBanner_booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonInfoBanner_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonType",
          "kind": "LinkedField",
          "name": "lessonType",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LessonBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "849a7851b0750309f3469419602dd09d";

export default node;
